<template>
  <div class="confirmacao">
    <div class="modal-header">
      <h5 class="modal-title">
        {{ input.titulo }}
      </h5>
    </div>
    <div class="modal-body">
      {{ input.mensagem }}
    </div>
    <div class="modal-footer border-top-0">
        <div class="d-flex">
            <div class="p-2 flex-grow-1">
                
            </div>
            <div class="p-2">
                <b-button @click="$emit('dispensar')" variant="link" class="btn-sm text-uppercase">
                  Cancelar
                </b-button>
            </div>
            <div class="p-2">
                <b-button @click="$emit('fechar')" variant="primary" class="btn-sm text-uppercase">
                  Confirmar
                </b-button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalConfirmacao",
  props: ["input"]
};
</script>
